<section
  class="visualizations"
  [ngClass]="{
    noCharts: !charts || charts.length <= 0
  }"
>
  <div class="heading">Update/Add Chart</div>
  <div class="subheading">{{ tooltip }}</div>
  <mat-tab-group class="visualizationsTabs">
    <mat-tab label="Charts">
      <div cdkDropList id="list-2" cdkDropListConnectedTo="list-1">
        <span
          *ngFor="let chart of chartList"
          cdkDrag
          cdkDragBoundary=".chart-list"
          class="chart-visualization"
          [cdkDragData]="chart.type"
        >
          <div class="chart-placeholder" *cdkDragPlaceholder>
            Drop Chart here to add
          </div>

          <ng-container *ngIf="chart.enabled">
            <div
              class="chart_img"
              id="{{ chart.name.split(' ')[0] }}"
              *ngIf="chart.name != 'Existing'"
              (click)="switchChartDialog(chart.type)"
            >
              <fa-icon [icon]="chart.icon"></fa-icon>
              <div>{{ chart.name }}</div>
            </div>
            <div
              class="chart_img  {{ chart.class }}"
              id="{{ chart.name.split(' ')[0] }}"
              *ngIf="chart.name == 'Existing'"
            >
              <fa-icon [icon]="chart.icon"></fa-icon>
              <div>{{ chart.name }}</div>
            </div>
          </ng-container>
        </span>
      </div>
    </mat-tab>

    <mat-tab label="Objects">
      <div cdkDropList id="list-2" cdkDropListConnectedTo="list-1">
        <span
          *ngFor="let object of objectList"
          cdkDrag
          cdkDragBoundary=".chart-list"
          class="chart-visualization"
          [cdkDragData]="object.type"
        >
          <div class="chart-placeholder" *cdkDragPlaceholder>
            Drop Object here to add
          </div>
          <ng-container *ngIf="object.enabled">
            <div class="chart_img object" id="{{ object.type.details }}">
              <fa-icon [icon]="object.icon"></fa-icon>
              <div>{{ object.name }}</div>
            </div>
          </ng-container>
        </span>
      </div>
    </mat-tab>
  </mat-tab-group>
</section>
